import type { Observable } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import type { ResponseGQL } from './types';

const getSwagUrl = (contextPath: string): string => `${contextPath}/jsw2/graphql`;

const softwareReportVelocityTimeTrackingOptions = 'SoftwareReportVelocityTimeTrackingOptions';

const getQuery = (): string => `query ${softwareReportVelocityTimeTrackingOptions} {
    jira {
        timeTrackingOptions {
            workingHoursPerDay
            workingDaysPerWeek
            defaultUnit
            timeFormat
        }
    }
}`;

const fetchTimeTrackingOptions = (contextPath: string): Observable<ResponseGQL> =>
	fetchJson$(getSwagUrl(contextPath), {
		method: 'POST',
		body: JSON.stringify({
			operationName: softwareReportVelocityTimeTrackingOptions,
			query: getQuery(),
		}),
	});

export default fetchTimeTrackingOptions;
